<discussion-list [limit]="9" [config]="config"></discussion-list>
